import React, { useState } from 'react';
import { InstantSearch, SearchBox, Hits, RefinementList, Stats, Pagination, ClearRefinements } from 'react-instantsearch';
import { Filter } from 'lucide-react';
import { searchClient } from '../utils/algolia';
import LeadHit from './LeadHit';

const SearchView = () => {
  const [showFilters, setShowFilters] = useState(true);

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="p-6 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <h1 className="text-2xl font-bold text-gray-900">Search Leads Database</h1>
              <button
                onClick={() => setShowFilters(!showFilters)}
                className="flex items-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
              >
                <Filter className="w-4 h-4" />
                {showFilters ? 'Hide' : 'Show'} Filters
              </button>
            </div>
          </div>

          <InstantSearch searchClient={searchClient} indexName="leads">
            {showFilters && (
              <div className="p-6 border-b border-gray-200 bg-gray-50">
                <h2 className="text-lg font-semibold mb-4">Filters</h2>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <h3 className="font-medium text-gray-900 mb-2">Total Score</h3>
                    <RefinementList
                      attribute="totalScore"
                      transformItems={(items) =>
                        items.map((item) => ({
                          ...item,
                          label: item.label === '75' ? '75+' :
                                 item.label === '50' ? '50-74' :
                                 item.label === '25' ? '25-49' :
                                 item.label === '0' ? '0-24' : item.label,
                        }))
                      }
                    />
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-2">Lead Tier</h3>
                    <RefinementList attribute="leadTier" />
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-2">Company Size</h3>
                    <RefinementList attribute="companySize" />
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-2">Budget Status</h3>
                    <RefinementList attribute="budgetStatus" />
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-2">Timeline</h3>
                    <RefinementList attribute="timeline" />
                  </div>

                  <div>
                    <h3 className="font-medium text-gray-900 mb-2">Demo Request</h3>
                    <RefinementList attribute="demoRequested" />
                  </div>
                </div>

                <div className="mt-4">
                  <ClearRefinements />
                </div>
              </div>
            )}

            <div className="p-6">
              <div className="mb-6">
                <SearchBox
                  placeholder="Search leads..."
                  classNames={{
                    root: 'mb-6', // outer container div
                    form: 'flex items-center', // the <form> element
                    input: 'p-3 text-lg border border-gray-300 rounded-l-md w-96', // the <input> element
                    submit: 'p-3 bg-blue-600 text-white rounded-r-md', // submit button
                    reset: 'p-3', // reset button
                  }}
                />
              </div>

              <div className="mb-4">
                <Stats />
              </div>

              <Hits hitComponent={LeadHit} />

              <div className="mt-6">
                <Pagination />
              </div>
            </div>
          </InstantSearch>
        </div>
      </div>
    </div>
  );
};

export default SearchView;